/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import { colors } from '@mui/material';

const material_style = {
	primary: {
		main: '#8098b2'
	},
	secondary: {
		main: '#313F4F',
		dark: '#313F4F'
	},
	text: {
		primary: colors.grey[900],
		secondary: colors.grey[900],
		link: colors.blue[600],
		light_red: '#FF3131',
		dark_red: '#D2042D'
	}
};

export default material_style;
